export const SPLASH_SCREEN_STEP = 'splashScreen';
export const EXPLAINER_STEP = 'explainer';
